function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import SvgIcon from '@/components/svg-icon-nc';
export default {
  name: 'YourComponentName',
  components: {
    SvgIcon: SvgIcon
  },
  props: {
    modelValue: {
      type: null
    },
    isDimension: {
      type: Boolean,
      default: false
    },
    // 是否需要排序
    needSort: {
      type: Boolean,
      default: true
    },
    // 是否数据格式
    needFormat: {
      type: Boolean,
      default: true
    },
    // 是否有汇总方式
    needCalcMode: {
      type: Boolean,
      default: true
    },
    // 是否有修改名称
    needChangeAlias: {
      type: Boolean,
      default: true
    },
    chartType: {
      type: String,
      default: ''
    }
  },
  model: {
    prop: 'modelValue',
    // 默认是value
    event: 'modelValue' // 默认是input
  },
  data: function data() {
    return {
      visible: false,
      list: this.modelValue,
      calcMode: [{
        label: '求和',
        type: 'N',
        code: 'sum'
      }, {
        label: '计数',
        type: 'N|T',
        code: 'count'
      }, {
        label: '去重计数',
        type: 'N|T',
        code: 'uniqid_count'
      }, {
        label: '平均值',
        type: 'N',
        code: 'avg'
      }, {
        label: '最大值',
        type: 'N',
        code: 'max'
      }, {
        label: '最小值',
        type: 'N',
        code: 'min'
      }],
      textMode: [{
        label: '计数',
        type: 'N|T',
        code: 'count'
      }, {
        label: '去重计数',
        type: 'N|T',
        code: 'uniqid_count'
      }],
      CalcMode: {
        sum: '求和',
        count: '计数',
        uniqid_count: '去重计数',
        avg: '平均值',
        max: '最大值',
        min: '最小值'
      },
      numType: ['Integer', 'Decimal', 'Percent', 'Money'],
      options: [{
        value: '无',
        label: '无'
      }, {
        value: '%',
        label: '%'
      }, {
        value: '元',
        label: '元'
      }, {
        value: '万元',
        label: '万元'
      }, {
        value: '亿',
        label: '亿'
      }, {
        value: '美元',
        label: '美元'
      }, {
        value: '个',
        label: '个'
      }, {
        value: '位',
        label: '位'
      }, {
        value: '天',
        label: '天'
      }],
      sortPopoverRefs: null,
      dialogConf: {
        isShow: false,
        data: {},
        inx: 0
      }
    };
  },
  watch: {
    modelValue: {
      handler: function handler(val) {
        this.list = val;
      },
      deep: true
    }
  },
  mounted: function mounted() {
    this.list = this.modelValue;
  },
  methods: {
    modeValue: function modeValue(tag) {
      var val = [];
      var types = ['input_number', 'input_float', 'input_price', 'input_percentage'];
      if (types.includes(tag.form_value)) {
        val = this.calcMode;
      } else {
        val = this.textMode;
      }
      return val;
    },
    delCom: function delCom(inx) {
      this.list.splice(inx, 1);
      this.$emit('modelValue', this.list);
    },
    editAlias: function editAlias(tag) {
      tag.editAlias = tag.alias;
      tag.showEdit = true;
    },
    confirmAlias: function confirmAlias(tag) {
      if (tag.editAlias) {
        tag.alias = tag.editAlias;
        this.cannerAlias();
      }
    },
    cannerAlias: function cannerAlias() {
      this.visible = false;
    },
    onCalcModeChange: function onCalcModeChange(tag, target, inx) {
      // this.summaryPopoverRefs[inx].hide()
      // this.sortPopoverRefs[inx].hide()
      tag.calcMode = target;
      this.$emit('modelValue', this.list);
    },
    onSort: function onSort(tag, target, inx) {
      // this.fieldsPopoverRefs[inx].hide()
      // this.sortPopoverRefs[inx].hide()
      this.$emit('modelValue', this.list);
      this.$emit('onSort', {
        tag: tag,
        target: target
      });
    },
    needDisabledType: function needDisabledType() {
      var chartTypes = ['barChart', 'barXChart', 'lineChart'];
      return chartTypes.includes(this.chartType);
    },
    showDataFormat: function showDataFormat(tag, inx) {
      this.dialogConf.data = _objectSpread({}, tag);
      this.dialogConf.inx = inx;
      this.dialogConf.isShow = true;
    },
    getPreviewNum: function getPreviewNum() {
      var _this$dialogConf$data = this.dialogConf.data,
        thousandsSeparator = _this$dialogConf$data.thousandsSeparator,
        showDecimalPlaces = _this$dialogConf$data.showDecimalPlaces,
        decimalPlaces = _this$dialogConf$data.decimalPlaces;
      var previewStr = '99999999';
      if (showDecimalPlaces) {
        previewStr = Number(previewStr).toFixed(decimalPlaces);
      }
      if (thousandsSeparator) {
        previewStr = this.numberToCurrencyNo(previewStr);
      }
      return previewStr;
    },
    numberToCurrencyNo: function numberToCurrencyNo(value) {
      if (!value) return 0;
      var intPart = Math.trunc(value);
      var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      var floatPart = '';
      var valueArray = value.toString().split('.');
      if (valueArray.length === 2) {
        floatPart = valueArray[1].toString();
        return intPartFormat + '.' + floatPart;
      }
      return intPartFormat + floatPart;
    },
    confirmDataFormat: function confirmDataFormat() {
      this.$set(this.list, this.dialogConf.inx, _objectSpread(_objectSpread({}, this.list[this.dialogConf.inx]), this.dialogConf.data));
      this.dialogConf.isShow = false;
      this.$emit('modelValue', this.list);
    }
  }
};